import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initRiskDetail({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDetail', individualId),
      dispatch('fetchQuestionnaire', individualId),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDetail({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDetail(token, individualId);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCurrentQuestionnaire({
        token,
        individualId,
      });
      commit('setQuestionnaire', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
